module.exports = __webpack_public_path__ + "static/TW_Australia_FSL_508867-f699cda906a1d0672507162c6b9ec2b4.pdf";